import { render, staticRenderFns } from "./Projects_selection.vue?vue&type=template&id=00bc85ce&"
import script from "./Projects_selection.vue?vue&type=script&lang=js&"
export * from "./Projects_selection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports